import "../../../../../../../vue@3.5.18_typescript@5.2.2/node_modules/vue/dist/vue.runtime.esm-bundler.js";
import { dataTableInjectionKey as b } from "../interface.js";
import k from "../../../_internal/icon/src/Icon.js";
import w from "../../../_internal/icons/ChevronDown.js";
import y from "../../../dropdown/src/Dropdown.js";
import { defineComponent as D, inject as S, computed as f, h as d } from "../../../../../../../@vue_runtime-core@3.5.18/node_modules/@vue/runtime-core/dist/runtime-core.esm-bundler.js";
const p = "_n_all__", m = "_n_none__";
function x(e, t, n, o) {
  return e ? (l) => {
    for (const r of e)
      switch (l) {
        case p:
          n(!0);
          return;
        case m:
          o(!0);
          return;
        default:
          if (typeof r == "object" && r.key === l) {
            r.onSelect(t.value);
            return;
          }
      }
  } : () => {
  };
}
function P(e, t) {
  return e ? e.map((n) => {
    switch (n) {
      case "all":
        return {
          label: t.checkTableAll,
          key: p
        };
      case "none":
        return {
          label: t.uncheckTableAll,
          key: m
        };
      default:
        return n;
    }
  }) : [];
}
const I = D({
  name: "DataTableSelectionMenu",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    }
  },
  setup(e) {
    const {
      props: t,
      localeRef: n,
      checkOptionsRef: o,
      rawPaginatedDataRef: l,
      doCheckAll: r,
      doUncheckAll: v
    } = S(b), h = f(() => x(o.value, l, r, v)), _ = f(() => P(o.value, n.value));
    return () => {
      var a, c, u, i;
      const {
        clsPrefix: s
      } = e;
      return d(y, {
        theme: (c = (a = t.theme) === null || a === void 0 ? void 0 : a.peers) === null || c === void 0 ? void 0 : c.Dropdown,
        themeOverrides: (i = (u = t.themeOverrides) === null || u === void 0 ? void 0 : u.peers) === null || i === void 0 ? void 0 : i.Dropdown,
        options: _.value,
        onSelect: h.value
      }, {
        default: () => d(k, {
          clsPrefix: s,
          class: `${s}-data-table-check-extra`
        }, {
          default: () => d(w, null)
        })
      });
    };
  }
});
export {
  I as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/data-table/src/TableParts/SelectionMenu.js
// module id = 1613
// module chunks = 41